import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table, Button, Form, Modal, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const EnquiryForm = () => {
  const [getEnquiry, setGetEnquiry] = useState([]);
  const [noChangeData, setNoChangeData] = useState([]);
  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);

  // Fetch Enquiries
  const getAllEnquiries = async () => {
    try {
      const res = await axios.get("/api/user/getallenquiry");
      if (res.status === 200) {
        setGetEnquiry(res.data);
        setNoChangeData(res.data);
      }
    } catch (error) {
      console.error("Error fetching enquiries:", error);
    }
  };

  // Search Filter
  const handleFilter = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    if (value !== "") {
      const filteredData = noChangeData.filter((item) =>
        Object.values(item).some((field) =>
          String(field).toLowerCase().includes(value)
        )
      );
      setGetEnquiry(filteredData);
    } else {
      setGetEnquiry(noChangeData);
    }
  };

  // Handle Delete Modal
  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setSelectedEnquiry(id);
    setShow(true);
  };

  // Delete Enquiry
  const deleteEnquiry = async () => {
    try {
      const res = await axios.delete(`/api/user/deleteenquiry/${selectedEnquiry}`);
      if (res.status === 200) {
        alert("Enquiry Deleted Successfully");
        getAllEnquiries();
        handleClose();
      }
    } catch (error) {
      console.error("Error deleting enquiry:", error);
    }
  };

  useEffect(() => {
    getAllEnquiries();
  }, []);

  return (
    <div className="container mt-5">
      <div className="row mb-3">
        <div className="col-md-4">
          <InputGroup className="mb-3">
            <InputGroup.Text><FontAwesomeIcon icon={faMagnifyingGlass} /></InputGroup.Text>
            <Form.Control
              placeholder="Search"
              onChange={handleFilter}
            />
          </InputGroup>
        </div>
      </div>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>S.No</th>
            <th>User Type</th>
            <th>Name</th>
            <th>Email</th>
            <th>Contact No.</th>
            <th>Qualification</th>
            <th>Subject Expertise</th>
            <th>Experience (Teacher)</th>
            <th>Message</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {getEnquiry.map((item, index) => (
            <tr key={item._id}>
              <td>{index + 1}</td>
              <td>{item.userType}</td>
              <td>{item.EName || item.TName}</td>
              <td>{item.EEmail || "N/A"}</td>
              <td>{item.EPhone || "N/A"}</td>
              <td>{item.EQualification || item.TQualification || "N/A"}</td>
              <td>{item.TSubject || "N/A"}</td>
              <td>{item.TExperience || "N/A"}</td>
              <td>{item.Emsg || "N/A"}</td>
              <td>
                <FontAwesomeIcon
                  icon={faTrash}
                  style={{ color: "red", cursor: "pointer" }}
                  onClick={() => handleShow(item._id)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Delete Confirmation Modal */}
      <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#c0392b" }}>Delete Enquiry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>Are you sure you want to delete this enquiry?</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          <Button variant="danger" onClick={deleteEnquiry}>Delete</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EnquiryForm;
